// extracted by mini-css-extract-plugin
export default {"wrapper":"ADSProductSelector_wrapper__skiD7","textWrapper":"ADSProductSelector_textWrapper__lB8kl","active":"ADSProductSelector_active__JQg6a"};